const PencilIcon = ({ size = 25, fill = '#231F20', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2479 3.44336L21.9979 7.19336L19.4679 9.73336L15.7179 5.98336L18.2479 3.44336ZM3.58789 21.8534V18.1034L14.6479 7.04336L18.3979 10.7934L7.33789 21.8534H3.58789Z"
        fill={fill}
      />
    </svg>
  );
};

export default PencilIcon;
